import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOFMFDRelocationByOrderId(orderId) {
  const response = await $.soap({
    body: {
      GetOFMFDRelocationByOrderId: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_form',
        OrderId: orderId
      }
    },
    blueprint: {
      order: {
        orderId: '$..OrderID',
        fromOrgUnit: '$..FromOrgUnit',
        fromBase: '$..FromBase',
        fromAddressId: '$..FromAddressID',
        fromStandardPocId: '$..FromStandardPOCID',
        fromItPocId: '$..FromITPOCID',
        deviceMake: '$..DeviceMake',
        deviceModel: '$..ModelNumber',
        deviceSerialNumber: '$..SerialNumber',
        isOverFiftyMiles: '$..IsOverFiftyMiles',
        relocationDate: '$..RelocationDate',
        fromSpecialInstructions: '$..FromSpecialInstructions',
        fromIsLoadingDock: '$..FromIsLoadingDock',
        fromIsHandicapRamp: '$..FromIsHandicapRamp',
        fromInternalStairs: '$..FromInternalStairs',
        fromNumInternalStairs: '$..FromNumInternalStairs',
        fromIsElevatorAvailable: '$..FromIsElevatorAvailable',
        fromFloorCoveringsReq: '$..FromFloorCoveringsReq',
        fromHasSecurityAccessReq: '$..FromHasSecurityAccessReq',
        fromSecurityAccessReqNotes: '$..FromSecurityAccessReqNotes',
        fromTrailer: '$..FromTrailer',
        fromNumExternalSteps: '$..FromNumExternalSteps',
        toOrgUnit: '$..ToOrgUnit',
        toBase: '$..ToBase',
        toAddressId: '$..ToAddressID',
        toStandardPocId: '$..ToStandardPOCID',
        toItPocId: '$..ToITPOCID',
        toSpecialInstructions: '$..ToSpecialInstructions',
        toIsLoadingDock: '$..ToIsLoadingDock',
        toIsHandicapRamp: '$..ToIsHandicapRamp',
        toInternalStairs: '$..ToInternalStairs',
        toNumInternalStairs: '$..ToNumInternalStairs',
        toIsElevatorAvailable: '$..ToIsElevatorAvailable',
        toFloorCoveringsReq: '$..ToFloorCoveringsReq',
        toHasSecurityAccessReq: '$..ToHasSecurityAccessReq',
        toSecurityAccessReqNotes: '$..ToSecurityAccessReqNotes',
        toTrailer: '$..ToTrailer',
        toNumExternalSteps: '$..ToNumExternalSteps',
        firstName: '$..POCFirstName',
        lastName: '$..POCLastName',
        email: '$..POCEmail',
        telephone: '$..POCTelephone'
      }
    }
  });

  cleanUpResponse(response);
  return response.order;
}
